import { useUIChangeEffect } from '../App.vue'

const { changeBig } = useUIChangeEffect()

const load = {
    big() {
        changeBig.big = true

    },

    small() {
        changeBig.big = false
    }
}
export { load, changeBig }